import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Textarea } from "@/components/elements/Textarea";
import { CollapsibleSectionHeader, useCollapsible } from "@/features/talent/components/talent-common/CollapsibleSectionHeader";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { divider } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Stack, Grid, Collapse } from "@mui/material";
import { useFormContext } from "react-hook-form";

type TalentFormMemoProps = {
  bordered?: boolean;
};

export const TalentFormMemo: FCC<TalentFormMemoProps> = ({ bordered = true }) => {
  const methods = useFormContext<TTalentForm>();
  const { control } = methods;
  const { expanded, toggle } = useCollapsible();

  return (
    <InnerBox mt={4} p={bordered ? 3 : 0} showDivider={false} borderColor={divider.high} bordered={bordered}>
      <CollapsibleSectionHeader title="特性メモ" expanded={expanded} onToggle={toggle} />

      <Collapse in={expanded}>
      <Stack mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormField control={control} name="memo" noLabel currentValueType="multiline">
              <Textarea placeholder="入力してください" />
            </FormField>
          </Grid>
        </Grid>
      </Stack>
      </Collapse>
    </InnerBox>
  );
};
